var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPeninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.875 9.913v1.9a.31.31 0 00.313.312h1.9a.293.293 0 00.218-.094l6.825-6.818-2.344-2.344L.97 9.688a.307.307 0 00-.094.225zM11.944 3.4a.622.622 0 000-.881L10.48 1.056a.622.622 0 00-.881 0L8.456 2.2 10.8 4.544 11.944 3.4z",
    fill: "inline"
  })));
}

export default SvgPeninline;